export default Object.freeze({
  PENDING: 'PENDING',
  PROPOSED: 'PROPOSED',
  ACCEPTED: 'ACCEPTED',
});
